import * as React from 'react'
import {
  Button,
  Container,
  FormGroup,
  FormText,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader } from 'reactstrap'
import * as App from '../../app'
import * as FlashMessage from '../../components/flash-message'
import * as Link from '../link'
import { Loading } from '../loading'
import * as RasaModal from '../modal'
import * as Types from './types'
import * as Utils from './utils'

export interface HelpProps {
  helpText: string,
  title: string,
}

type ModalProps = RasaModal.ComponentState<Types.ModalImageData> &
                  RasaModal.CloseDispatchState &
                  RasaModal.UpdateDispatchState &
                  RasaModal.SubmitDispatchState<Types.ModalImageData> &
                  App.WrappedState &
                  HelpProps &
                  {flashMessage?: FlashMessage.SetMessageActionCreator}

export const ImageUploadModal =
({app, modal, closeModal, submitModal, updateModal, title, helpText, flashMessage}: ModalProps) => {
  return (
    <div>
      <Modal className="modal-lg" isOpen={modal.isOpen} toggle={closeModal}>
        <form onSubmit={Link.preventDefaultThen(
          () => submitModal(app.selectedCommunity, modal.data))}>
          <ModalHeader toggle={closeModal}>{title}</ModalHeader>
          <ModalBody>
            <FormGroup>
                <FlashMessage.FlashMessage />
              <Container>
                <FormText color="muted">{helpText}</FormText>
                <Input type="file"
                       accept="image/*"
                       placeholder="File to upload."
                       onChange={(e) => RasaModal.handleLogoFileChange(
                         updateModal,
                         flashMessage,
                         e.target.files)} >
                </Input>
              </Container>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            {modal.isSubmitting ? <Loading size={Loading.Sizes.SMALL}/> : <span/>}
            <Button color="primary" disabled={!Utils.validateImage(modal.data.file)}>
              Update
            </Button>
            <Button onClick={closeModal}>Cancel</Button>
          </ModalFooter>
        </form>
      </Modal>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/image/component.tsx